import { memo } from 'react';

const RefreshControls = memo(({
  stockslength,
  isRefreshing,
  refreshAllStocks,
  refreshInterval,
  setRefreshInterval,
}) => {
    const refreshStatus = stockslength > 0
        ? `Auto-refreshing every ${refreshInterval/1000} seconds`
        : "Add stocks to enable auto-refresh";
    return (
        <div className="refresh-controls">
            <button onClick={refreshAllStocks} disabled={isRefreshing}>
                {isRefreshing ? 'Refreshing...' : 'Refresh Now'}
            </button>
            <span>Auto-refresh every:</span>
            <select
                value={refreshInterval}
                onChange={(e) => {
                    const newInterval = parseInt(e.target.value);
                    setRefreshInterval(newInterval);
                    localStorage.setItem('refreshInterval', newInterval.toString());
                }}
            >
                <option value={30000}>30 sec</option>
                <option value={60000}>1 min</option>
                <option value={300000}>5 min</option>
                <option value={900000}>15 min</option>
                <option value={0}>Off</option>
            </select>
            <div className={`refresh-status ${isRefreshing ? 'refresh-updated' : ''}`}
                style={{ color: refreshInterval > 0 ? "#4CAF50" : "#666" }}>
                {refreshStatus}
            </div>
        </div>
    );
});

export default RefreshControls;